import {
  Component,
  computed,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { LayoutService } from '../../service/layout.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { BrandingService } from 'src/app/core/branding/branding.service';
import { ActiveTenantMenuComponent } from '../active-tenant-menu/active-tenant-menu.component';
import { UserStore } from 'src/app/core/auth/user/store/user.store';
import { UserRole } from 'src/app/core/auth/user/enum/user-role.enum';

@Component({
  selector: '[app-sidebar]',
  standalone: true,
  imports: [
    CommonModule,
    MenuComponent,
    RouterModule,
    TopbarComponent,
    ActiveTenantMenuComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
  private readonly brandingService = inject(BrandingService);
  private readonly branding = this.brandingService.branding;
  private readonly userStore = inject(UserStore);

  readonly brandName = computed(() => this.branding()?.label ?? '');
  readonly logoUrl = computed(() => this.branding()?.logoUrl ?? '');
  readonly showLogo = computed(() => this.branding()?.showLogo ?? false);

  readonly showTenantMenu = computed(() => {
    const user = this.userStore.user();
    const clients = user?.clients ?? [];
    return this.userStore.hasRole(UserRole.Customer) && clients.length > 1;
  });

  timeout: any = null;

  isHorizontal = computed(() => this.layoutService.isHorizontal());

  isDarkTheme = computed(() => this.layoutService.isDarkTheme());

  @ViewChild('menuContainer') menuContainer!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
  ) {}

  onMouseEnter() {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update((state) => {
        if (!state.sidebarActive) {
          return {
            ...state,
            sidebarActive: true,
          };
        }
        return state;
      });
    }
  }

  onMouseLeave() {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((state) => {
            if (state.sidebarActive) {
              return {
                ...state,
                sidebarActive: false,
              };
            }
            return state;
          });
        }, 300);
      }
    }
  }

  anchor() {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      anchored: !state.anchored,
    }));
  }
}
